import {TagDetailsResponseSchema, TagResponseSchema} from '../../tags';
import {TagName} from '../../validation';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';
import {ObjectIdSchema} from '../../zod';

export const GetTags = {
  path: 'tags',
  method: 'get',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({}),
  responseDataSchema: TagResponseSchema.array(),
} satisfies ApiDefinition;

export const GetTagsWithDetails = {
  path: 'tags/getTagsWithDetails',
  method: 'get',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({}),
  responseDataSchema: TagDetailsResponseSchema.array(),
} satisfies ApiDefinition;

const TagNameErrorMessage = `Tag names should be between ${TagName.minLength} and ${TagName.maxLength} characters, and contain only letters and numbers.`;
export const SaveTag = {
  path: 'tags/saveTag',
  method: 'post',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({
    id: ObjectIdSchema.optional(),
    name: z
      .string()
      .regex(TagName.pattern, TagNameErrorMessage)
      .min(TagName.minLength, TagNameErrorMessage)
      .max(TagName.maxLength, TagNameErrorMessage),
  }),
  responseDataSchema: TagResponseSchema,
} satisfies ApiDefinition;

export const DeleteTag = {
  path: 'tags/deleteTag',
  method: 'post',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({
    tagId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
